import Dodone from 'models/dodone'
import CloseDateTime from 'app/inputs/CloseDateTime'
import DurationPicker from 'app/inputs/DurationPicker'
import DodoneCommentField from 'app/dodones/fields/comment/Index'

const EditAttribute = ({ attribute, onChange, value }) => {
  if (attribute.name == 'comment')
    return <DodoneCommentField onChange={onChange} value={value} />

  if (attribute.type == 'datetime')
    return <CloseDateTime onChange={onChange} value={value || new Date()} />

  if (attribute.name == 'timeout')
    return <DurationPicker onChange={onChange} value={value || 1800} />

  return (
    <div> {`implement input for ${attribute.type}/${attribute.name}`} </div>
  )
}

export default ({ attribute, onChange, value, label = true }) => {
  const changed = useCallback((value) => {
    onChange(attribute.name, value)
  })

  return (
    <div>
      {label ? (
        <div className="text-center"> {attribute.humanName} </div>
      ) : null}
      <EditAttribute attribute={attribute} onChange={changed} value={value} />
    </div>
  )
}
